import MessagesCollection from "../../message/collection"
import Message from "../../message/message"
import ApiGoal from "../../../gd/api/goal";
import Goal from "../goal";

const debug = false
// const debug = "GoalMessagesCollection"

export default class GoalMessagesCollection extends MessagesCollection {

    private goal?: Goal

    constructor(models: Message[]) {
        super(models)
    }

    static initFromJson(data: any): GoalMessagesCollection {
        const models: Message[] = []

        _.map(data, (record: JSONObject) => {
            models.push(new Message(record))
        })

        return new GoalMessagesCollection(models)
    }

    setGoal(goal:Goal) {
        this.goal = goal
    }

    async add(model: Message, withApiCall: boolean = false) {
        if (withApiCall && this.goal) {
            const response:any = await ApiGoal.addComment(this.goal.id, model).promise()
            model.id = response.id

            debug && console.log(debug, 'add', model, response)
        }

        const existingGoal = this.get(model.id)
        if (existingGoal) {
            existingGoal.applyDelta(model.toJSON())
        } else {
            super.add(model)
        }
    }

    remove(id: ID, withApiCall: boolean = false): Message[] {
        if (withApiCall && this.goal) ApiGoal.deleteComment(this.goal.id, id)
        return super.remove(id)
    }

    replace(id: ID, model: Message, withApiCall: boolean = false) {
        super.replace(id, model)
        if (withApiCall && this.goal) ApiGoal.editComment(this.goal.id, model)
    }
}
